import { Component,  Input } from '@angular/core';
import { BaseComponent } from '../base-component/base.component';
import { ShipmentAction, UserType } from '@shared-features/enums';

@Component({
  selector: 'app-gate-to-gate-timeline',
  templateUrl: './gate-to-gate-timeline.component.html',
  styleUrls: ['./gate-to-gate-timeline.component.scss'],
})
export class GateToGateTimelineComponent extends BaseComponent {
  @Input() history;
  protected readonly ShipmentAction = ShipmentAction;

  constructor() {
    super();
  }

  public get UserType(): typeof UserType {
    return UserType;
  }
}
